module.exports = __webpack_public_path__ + "static/media/clem-onojegaw.0d005146.jpg";